module.exports = __webpack_public_path__ + "img/wx_out_trade_num.cd5e497a.png";